import React, { useCallback } from 'react';

import BaseAgGridTable from 'Components/AgGrid/BaseAgGridTable';
import { useDarkMode } from 'Hooks/useDarkMode';
import {
  firstName,
  lastName,
  destination,
  country,
  iataCode,
  season,
  staffSourceMarket,
  confirmedFlightDate,
  typeOfFlight,
} from 'Components/AgGrid/commonColumnDefs';

const columns = [
  firstName(),
  lastName(),
  destination(),
  country(),
  iataCode(),
  season(),
  staffSourceMarket(),
  confirmedFlightDate(),
  typeOfFlight(),
];

const StatusConfirmedAgGridTable = () => {
  const { darkMode } = useDarkMode();

  const getRowStyle = useCallback(
    (params) => {
      if (params.data?.confirmedStatus?.toLowerCase() === 'modified') {
        return { background: darkMode ? '#5a4a3a' : '#fcdab6' };
      }
      if (params.data?.confirmedStatus?.toLowerCase() === 'cancelled') {
        return { background: darkMode ? '#5a3a3a' : '#fcaeae' };
      }
      if (params.data?.status?.toLowerCase() === 'confirmed') {
        return { background: darkMode ? '#3a5a4a' : '#c9f2d6' };
      }
      return { background: darkMode ? '#2e2e2e' : '' };
    },
    [darkMode]
  );

  return (
    <BaseAgGridTable
      endpoint="staff/agGridTable/Confirmed"
      viewName="StatusConfirmed"
      statusPath="confirmed"
      columns={columns}
      getRowStyle={getRowStyle}
    />
  );
};

export default StatusConfirmedAgGridTable;
